import React from "react";
import PropTypes from "prop-types";

import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";

import PaginatorTemplate from "./templates/PaginatorTemplate";

export class Paginator extends React.Component {

    constructor(props) {
        super(props);
        const { page, pageSize } = props;

        this.state = {
            pageNumber: page + "",
            pageSize: pageSize + "",
            originalPageSize: pageSize + ""
        };

    }

    render() {
        const { pageCount } = this.props;

        const start = this.getStart();
        const end = this.getEnd();
        const hasNextPage = this.getHasNextPage();
        const hasPreviousPage = this.getHasPreviousPage();

        return (<PaginatorTemplate
            pageCount={pageCount}
            hasPreviousPage={hasPreviousPage}
            hasNextPage={hasNextPage}
            start={start}
            end={end}
            pageNumber={this.state.pageNumber}
            pageSize={this.state.pageSize}
            onPageNumberChange={this.onPageNumberChange.bind(this)}
            onPageSizeChange={this.onPageSizeChange.bind(this)}
            onPaginatorPageNext={this.onPaginatorPageNext.bind(this)}
            onPaginatorPagePrevious={this.onPaginatorPagePrevious.bind(this)}
            onPaginatorSubmit={this.onPaginatorSubmit.bind(this)}
        />);
    }

    onPaginatorPageNext(event) {
        event.preventDefault();
        const { page } = this.props;
        const { originalPageSize } = this.state;
        this.dispatchSearch(page + 1, originalPageSize);
    }

    onPaginatorPagePrevious(event) {
        event.preventDefault();
        const { page } = this.props;
        const { originalPageSize } = this.state;
        this.dispatchSearch(page - 1, originalPageSize);
    }

    onPaginatorSubmit(event) {
        event.preventDefault();
        const { pageSize, pageNumber } = this.state;
        this.dispatchSearch(pageNumber, pageSize);
    }

    dispatchSearch(page, pageSize) {
        const { search } = this.props;
        search(page, pageSize);
    }

    onPageNumberChange(event) {
        const value = event.target.value;
        this.setState({
            pageNumber: value
        });
    }

    onPageSizeChange(event) {
        const value = event.target.value;
        this.setState({
            pageSize: value
        });
    }

    getStart() {
        const { pageSize, page } = this.props;
        if (pageSize == null) {
            return 1;
        }
        const zeroIndexPageNumber = page - 1;
        return zeroIndexPageNumber * pageSize + 1;
    }

    getEnd() {
        const { pageSize, page, results } = this.props;
        if (pageSize == null) {
            return 0;
        }
        const zeroIndexPageNumber = page - 1;
        const currentPageLength = results ? results.length : 0;
        return zeroIndexPageNumber * pageSize + currentPageLength;
    }

    getHasNextPage() {
        const { page, pageCount } = this.props;
        if (pageCount == null) {
            return false;
        }
        return page < pageCount;
    }

    getHasPreviousPage() {
        const { page } = this.props;
        return page > 1;
    }

}

Paginator.propTypes = {
    search: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    results: PropTypes.object
};

const config = (props) => ({
  search: (page, pageSize) => {
      const model = props.model;
      if (parseInt(pageSize)) {
          model.set("pageSize", pageSize);
      }
      if (model.hasChanged("pageSize")) {
          model.resetPagination();
      } else {
          if (parseInt(page)) {
              model.set("page", page);
          }
      }
      props.view.dispatch("search:dataQualityReport", model);
  },
    page: {listenOn: "model"},
    pageSize: {listenOn: "model"},
    pageCount: {listenOn: "searchResults"},
    results: {listenOn: "searchResults"}
});

export const BackbonePaginator = backboneConnect(config)(Paginator);



// WEBPACK FOOTER //
// ./app/lib/dqr/views/results/lib/paginator/Paginator.js